<template>
  <div id="cup_sportsHall">
    <span class="dev">待完善</span>
    <!-- <HTML_POINT_LAYOUT></HTML_POINT_LAYOUT> -->
    <!-- <MATCHSTATE_KEYEVENT_LINE></MATCHSTATE_KEYEVENT_LINE> -->
    <!-- <MATCHSTATE_KEYEVENT_BAR></MATCHSTATE_KEYEVENT_BAR> -->
    <!-- 胜率预测 -->
    <!-- <WINRATEPREDICTION_BAR></WINRATEPREDICTION_BAR> -->
    <!-- <PASSINGSTYLE_PIE :currThemeObj="currThemeObj"></PASSINGSTYLE_PIE> -->
    <!-- <img :src="imageBase64" /> -->
  </div>
</template>

<script>
import cup_base_data_mixin from '@mixins/cup_base_data'
import base64 from './base64.js'
import HTML_POINT_LAYOUT from '@components/football/html/HTML_POINT_LAYOUT/index.vue'
import MATCHSTATE_KEYEVENT_LINE from '@components/football/echarts/line/matchState_keyEvent_line.vue'
import MATCHSTATE_KEYEVENT_BAR from '@components/football/echarts/bar/matchState_keyEvent_bar.vue'
import WINRATEPREDICTION_BAR from '@components/football/echarts/bar/winRatePrediction_bar.vue'
import PASSINGSTYLE_PIE from '@components/football/echarts/pie/passingStyle_pie.vue'
export default {
  name: 'cup_sportsHall',
  mixins: [cup_base_data_mixin],
  components: {
    // HTML_POINT_LAYOUT,
    // MATCHSTATE_KEYEVENT_LINE
    // MATCHSTATE_KEYEVENT_BAR,
    // WINRATEPREDICTION_BAR,
    // PASSINGSTYLE_PIE,
  },
  data() {
    return {
      imageBase64: '',
    }
  },
  created() {
    window.mixtmtBase_eventBus.$emit('loadingEvent', false)
    console.debug('base64:', base64)
    this.imageBase64 = base64.base64
  },
}
</script>

<style lang="scss" scoped>
.dev {
  display: block;
  text-align: center;
  font-size: 2.083vw;
  padding-top: 6.25vw;
}
#cup_sportsHall {
}
</style>
